module.exports = __webpack_public_path__ + "img/illust-02.03ef7bcb.png";